const EntityType = {
  ALERT: 1,
  SUBSCRIPTION: 2,
  DEVICE: 3,
  DATA_GROUP: 4,
  USER: 5,
  ACCOUNT_MESSAGE: 6,
  ALERT_COMMENT: 7,
  THRESHOLD_RANGE: 8,
  THRESHOLD_RANGE_GROUP: 9,
  USER_ALERT_DATA: 10,
  USER_ASSIGNMENT: 11,
  PENDING_USER_ASSIGNMENT: 12,
  SAVED_SEARCH: 13,
  TAG: 14,
  ROOM_ALERT_LINK: 15,
  NOTIFICATION_GROUP: 16,
  NOTIFICATION_TEMPLATE: 17,
  QUIET_TIME: 18,
  SUBSCRIPTION_CHECKLIST: 19,
  SUBSCRIPTION_CHECKLIST_ENTRY: 20,
};
// eslint-disable-next-line import/prefer-default-export
export { EntityType };
